export const blacklistedUrls = [
  'bahrainbourse.com',
  '24exchange.com',
  'aastocks.com/en',
  'abs.org.sg',
  'adx.ae',
  'actus.fr',
  'cboe.com',
  'fanniemae.com',
  'asiapacificex.com',
  'aquis.eu',
  'asx.com.au',
  'newsaktuell.com',
  'bmfbovespa.com.br',
  'msci.com',
  'neeq.com.cn',
  'bse.com.lb',
  'bloomberg.com',
  'bmemarketdata.es/ing/Home',
  'business.bofa.com',
  'boerse-stuttgart.de',
  'bolsadesantiago.com',
  'bolsadequito.com',
  'bolsadevalores.com.py',
  'bolchile.cl',
  'borsaitaliana.it',
  'bsse.sk',
  'businesswire.com',
  'caixinglobal.com',
  'casablanca-bourse.com',
  'cbf.cl',
  'batstrading.com',
  'cesc.com/en',
  'cfbf.cz',
  'cfets-nex.com.cn/en',
  'cmegroup.com',
  'ccxi.com.cn/en',
  'cffex.com.cn',
  'csrc.gov.cn',
  'ciis.com.hk',
  'prnewswire.com',
  'szse.cn',
  'nuamx.com',
  'cse.lk',
  'bolsacr.com',
  'ukfinance.org.uk',
  'scb.se',
  'crunchbase.com',
  'dnb.com',
  'dce.com.cn',
  'dse.sy',
  'gfex.com.cn',
  'stoxx.com',
  'dfbf.dk',
  'dsebd.org',
  'teleborsa.it',
  'dowjones.com',
  'dtcc.com',
  'dfm.ae',
  'exchange-data.com',
  'eex.de',
  'egidegypt.com',
  'emmi-benchmarks.eu',
  'enexgroup.gr',
  'epexspot.com/en',
  'euroclear.com',
  'fastmarkets.com',
  'euronext.com',
  'nasdaq.com',
  'fca.org.uk',
  'fundinfo.com',
  'fexglobal.com.au',
  'finra.org',
  'finwire.se',
  'fondbolagen.se',
  'spglobal.com',
  'fxanalytics.com',
  'gfo-x.com',
  'griffinmarkets.com',
  'hkex.com.hk',
  'hkma.gov.hk',
  'houstonstreet.com',
  'idd.ice.com',
  'indices.ice.com',
  'ideacarbon.org',
  'lsx.com.la/en',
  'infront.co',
  'interfax.com',
  'jpmorgan.com/securities-services',
  'jcr.co.jp',
  'jpx.co.jp/jscc/en',
  'jsda.or.jp/en',
  'jiji.com',
  'japannext.co.jp',
  'jse.co.za',
  'jpmorganchase.com',
  'jpx.co.jp',
  'english.koscom.co.kr',
  'boursakuwait.com.kw',
  'kyodo.co.jp',
  'leba.org.uk',
  'lexisnexis.com/en-sg',
  'met.no',
  'bvl.com.pe',
  'lme.com',
  'londonstockexchange.com',
  'ltse.com',
  'bourse.lu',
  'mae.com.ar',
  'mse.co.mw',
  'borzamalta.com.mt',
  'stockexchangeofmauritius.com',
  'bmv.com.mx',
  'mexder.com.mx',
  'moodys.com',
  'morganstanley.com',
  'morningstar.com',
  'msx.om',
  'mcxindia.com',
  'nyse.com',
  'nikkei.co.jp',
  'ngm.se',
  'nordpoolgroup.com',
  'nse.co.ke',
  'nzx.com',
  'oekb.at',
  'opraplan.com',
  'odx.co.jp/en',
  'odex.co.jp/en/index.html',
  'jpx.co.jp',
  'otcmarkets.com',
  'preqin.com',
  'idx.co.id',
  'boerse-duesseldorf.de/quotrix',
  'r-i.co.jp',
  'reutersagency.com',
  'russellinvestments.com',
  'rse.rw',
  'spglobal.com/spdji',
  'saudiexchange.sa',
  'swfbf.se',
  'sgx.com',
  'en.sge.com.cn',
  'ine.cn',
  'en.sse.net.cn',
  'goldmansachs.com',
  'six-group.com',
  'tpex.org.tw',
  'tdcc.com.tw',
  'taifex.com.tw',
  'twse.com.tw/en',
  'infrontfinance.com',
  'tase.co.il',
  'tfex.co.th',
  'ngxgroup.com',
  'tfx.co.jp',
  'stockex.co.tt',
  'bvmt.com.tn',
  'gpw.pl/en-home',
  'wienerborse.at',
  'en.exbxg.com',
  'tradeweb.com',
  'english.czce.com.cn',
  'apple.com',
  'enanchu.com',
  'ksd.or.kr/en',
  'uxc.com',
  'bundesbank.de/en',
  'bnb.bg',
  'bankofengland.co.uk',
  'epa.nsw.gov.au',
  'environment.qld.gov.au',
  'icra.in',
  'metroag.de/en',
  'opencorporates.com',
  'organon.com',
  'ovintiv.com',
  'quartr.com',
  'db.com',
  'besi.com',
  'hapag-lloyd.com',
  'snam.it/en/home.html',
  'airleasecorp.com',
  'tdsecurities.com',
  'argusmedia.com',
  'asx.com.au',
  'bgcg.com',
  'bitsight.com',
  'bloomberg.com',
  'bme-group.com',
  'candeal.com',
  'cboe.com',
  'chinamoney.org.cn',
  'cmegroup.com',
  'creditsafe.com',
  'dnb.com',
  'deutsche-boerse.com',
  'cwan.com',
  'euronext.com',
  'exchange-data.com',
  'factset.com',
  'fefundinfo.com',
  'finastra.com',
  'fondbolagen.se',
  'fundsquare.net',
  'hkex.com.hk',
  'ibm.com',
  'ice.com',
  'industrialinfo.com/iirenergy',
  'koscom.co.kr',
  'lmax.com',
  'lseg.com',
  'microsoft.com',
  'morningstar.com',
  'newscorp.com',
  'oekb.at',
  'preqin.com',
  'six-group.com',
  'statestreet.com',
  'tmx.com',
  'wilshire.com',
  'wmgruppe.de',
  'yna.co.kr',
  'smbs.biz/mobile/en/main/main.jsp',
  '4castweb.com',
  'aap.com.au',
  'abc.net.au',
  'awp.ch',
  'capelogic.com',
  'kaiko.com',
  'cicada.io',
  'citigroup.com',
  'consensuseconomics.com',
  'daiwa-grp.jp',
  'nichigai.co.jp',
  'dzh.traders.co.jp',
  'usatodayco.com',
  'hketgroup.com',
  'iextrading.com',
  'rapidratings.com',
  'itg.com',
  'memx.com',
  'nasdaqdubai.com',
  'ncdex.com',
  'nopa.org',
  'nsd.ru',
  'opisnet.com',
  'euromts-ltd.com',
  'conference-board.org/aboutus/offices.cfm',
  'tradingcentral.com',
  'trendsetterfx.com',
];
